export function omitWithCap(num: number, cap = 99) {
  return num > cap ? `${cap}+` : `${num}`;
}
